import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import PageTitle from '../components/PageTitle';
import PageSection from '../components/PageSection';

const styles = theme => ({
  intro: {
    marginTop: 30,
    marginBottom: 30,
    padding: 30,
    textAlign: 'center',
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 32
    }
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main
  }
});

const subjects = [
  {
    id: 1,
    title: 'Piano',
    description: 'Musicology Studio offers private beginner, intermediate, or advanced student-centered piano classes for students of all ages and developmental needs. Students are individually assessed, and an individualized and sequential program is created for each student that focuses on performance songs, technical exercises and theory.',
    image: 'https://musicology-studio.s3.amazonaws.com/PianoClass%403x.png',
  },
  {
    id: 2,
    title: 'Music Theory',
    description: 'Introductory and intermediate music theory lessons, exercises, and ear training. Understanding music theory helps to understand the language of music and explain the music we hear.',
    image: 'https://musicology-studio.s3.amazonaws.com/MusicTheory%403x.png',
  }
]

class Subjects extends Component {

  render() {

    const { classes } = this.props;
    return (
      <div>
        <PageTitle title="Subjects We Teach" />
        <Grid container
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={8}>
            <div className={classes.intro}>
              <Typography className={classes.introTitle} variant="h4">
                Benefits of Music Education
              </Typography>

              <Typography className={classes.font} variant="subtitle1">
                Research suggests that children, who learn and participate in music, acquire skills that help them in decision-making, problem-solving, creative thinking, and teamwork. An increasing number of studies also find that music programs motivate children to learn, assisting in improving performance in core academic subjects. For some children, music education provides the impetus to stay in school until graduation and, for others, the inspiration to pursue a college education.
              </Typography>
            </div>
            <Divider />
          </Grid>
        </Grid>

        {subjects.map(subject => <PageSection key={subject.id} section={subject} /> )}
      </div>
    )
  }
}

Subjects.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Subjects);
